import React from "react";
import { Gift } from "lucide-react";

const UpgradeSummary = ({ currentPlanName, newPlan, isTrial }) => {
  return (
    <div className="border rounded-lg p-4 bg-secondary/30 relative">
      <div className="flex justify-between flex-wrap items-center">
        <h3 className="font-semibold mb-2 text-base">
          {isTrial ? "Trial Summary:" : "Upgrade Summary:"}
        </h3>
        {isTrial && (
          <div className="flex items-center gap-1.5 px-3 py-1 bg-primary/15 text-primary rounded-full text-sm font-semibold">
            <Gift className="w-4 h-4" />
            30-Day Free Trial
          </div>
        )}
      </div>

      <div className="flex justify-between items-center mt-6">
        <span className="text-muted-foreground">Current Plan:</span>
        <span className="font-medium">{currentPlanName} Tier</span>
      </div>

      <div className="flex justify-between items-center mt-2">
        <span className="text-muted-foreground">New Plan:</span>
        <span className="font-bold text-base md:text-lg text-primary">
          {newPlan.name}
        </span>
      </div>

      <div className="flex justify-between items-center mt-4 pt-4 border-t">
        <span className="text-muted-foreground text-sm md:text-base">
          {isTrial ? "Due Today:" : "Total Due Today:"}
        </span>
        <div className="text-right">
          <span className="text-lg md:text-2xl font-bold text-primary">
            {isTrial ? "FREE" : `$${newPlan.price}`}
          </span>
          {isTrial ? (
            <p className="text-xs text-muted-foreground mt-0.5">
              then ${newPlan.price}/{newPlan.frequency} after 30 days
            </p>
          ) : (
            newPlan.frequency && (
              <span className="text-xs text-muted-foreground ml-1">
                /{newPlan.frequency}
              </span>
            )
          )}
        </div>
      </div>

      {isTrial && (
        <p className="text-xs text-muted-foreground mt-3 text-center">
          Cancel anytime before your trial ends and you won't be charged.
        </p>
      )}
    </div>
  );
};

export default React.memo(UpgradeSummary);
